import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import TestQuestion from '../entities/testQuestion'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';


interface TestQuestionState extends ListState<TestQuestion> {
    editTestQuestion: TestQuestion;
    editSisterQuestion: TestQuestion;
    sisterInfoTestQuestion: TestQuestion;
    teacherListQuestion: TestQuestion;
    cascaders: any;
}
class TestQuestionModule extends ListModule<TestQuestionState, any, TestQuestion>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<TestQuestion>(),
        loading: false,
        editTestQuestion: new TestQuestion(),
        sisterInfoTestQuestion: new TestQuestion(),
        editSisterQuestion: new TestQuestion(),
        teacherListQuestion: new TestQuestion(),
        cascaders: new Array<Cascader>()
    }
    actions = {
        async getAll(context: ActionContext<TestQuestionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/TestQuestion/GetAllQuestion', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result.result as PageResult<TestQuestion>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        async getAllQuestionOfPaper(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TestQuestion/GetAllQuestionOfPaper', { params: payload.data });
            let page = reponse.data.result.result as PageResult<TestQuestion>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async previewTestPaper(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestQuestion/PreviewTestPaper', payload.data);

            return reponse.data.result;
        },


        async ChangeTestPaperOfQuestion(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestQuestion/ChangeTestPaperOfQuestion', payload.data);
            return reponse.data.result
        },


        async ImportQuestionFromWordFile(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestQuestion/ImportQuestionFromWordFile', payload.data);
            return reponse.data.result
        },


        async create(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestQuestion/CreateQuestion', payload.data);
            return reponse.data.result
        },
        async update(context: ActionContext<TestQuestionState, any>, payload: any) {
            await Ajax.put('/api/services/app/TestQuestion/UpdateQuestion', payload.data);
        },
        async delete(context: ActionContext<TestQuestionState, any>, payload: any) {
            await Ajax.delete('/api/services/app/TestQuestion/DeleteQuestion?Id=' + payload.data.id + "&QuestionType=" + payload.data.questionType);
        },

        async deletelist(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestQuestion/PostDeleteQuestions', payload.data);
            return reponse.data.result
        },

        async deletePaperOfQuestion(context: ActionContext<TestQuestionState, any>, payload: any) {
            await Ajax.delete('/api/services/app/TestQuestion/DeletePaperOfQuestion?Id=' + payload.data);
        },
        async auditedTestQuestion(context: ActionContext<TestQuestionState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/TestQuestion/AuditedTestQuestion', payload.data);
            context.state.loading = false;
        },

        async auditTestQuestionFlow(context: ActionContext<TestQuestionState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/TestQuestion/AuditTestQuestionFlow', payload.data);
            context.state.loading = false;
        },
        async importSisterQuestion(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestQuestion/ImportSisterQuestion', payload.data);
            return reponse.data.result;
        },
        async get(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TestQuestion/Get?Id=' + payload.id);
            return reponse.data.result as TestQuestion;
        },
        async getCascader(context: ActionContext<TestQuestionState, any>, payload: any) {
            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetBehindCascaderList', { params: payload.data });
            context.state.cascaders = reponse.data.result as Array<Cascader>;
            // context.state.loading = false;
        },

        async getNousCascader(context: ActionContext<TestQuestionState, any>, payload: any) {
            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            context.state.cascaders = reponse.data.result as Array<Cascader>;
            // context.state.loading = false;
        },


        async showStateSwitching(context: ActionContext<TestQuestionState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/TestQuestion/showStateSwitching', payload.data);
            context.state.loading = false;
        },
        async deleteSisterQuestion(context: ActionContext<TestQuestionState, any>, payload: any) {
            await Ajax.delete('/api/services/app/TestQuestion/DeleteSisterQuestion', { params: payload.data });
        },
        async exportTestPaper(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestQuestion/ExportTestPaper', payload.data);
            return reponse.data.result;
        },
        async getTopicOfStatistical(context: ActionContext<TestQuestionState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TestQuestion/getTopicOfStatistical?sectionId=' + payload.data.sectionId + '&BeginTime=' + payload.data.BeginTime + '&EndTime=' + payload.data.EndTime);
            return reponse.data.result;
        }
    };
    mutations = {
        setCurrentPage(state: TestQuestionState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: TestQuestionState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: TestQuestionState, testQuestion: TestQuestion) {
            state.editTestQuestion = testQuestion;
        },
        sisterInfo(state: TestQuestionState, testQuestion: TestQuestion) {
            state.sisterInfoTestQuestion = testQuestion;
        },
        editSister(state: TestQuestionState, testQuestion: TestQuestion) {
            state.editSisterQuestion = testQuestion;
        },
        teacherQuestion(state: TestQuestionState, testQuestion: TestQuestion) {
            state.teacherListQuestion = testQuestion;
        }

    }
}
const testQuestionModule = new TestQuestionModule();
export default testQuestionModule;